module.exports = __webpack_public_path__ + "static/media/back.1d0a3054.png";